import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as static_ddl_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			options: [
				{
					value: "U",
					text: "U.S. Citizen or U.S. National"
				},
				{
					value: "D",
					text: "U.S. Dual Citizen"
				},
				{
					value: "P",
					text: "U.S. Permanent Resident (Green Card Holder)"
				},
				{
					value: "R",
					text: "U.S. resident with other status"
				},
				{
					value: "O",
					text: "Other (Non-U.S.)"
				}
			]
		},
		static_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
